// extracted by mini-css-extract-plugin
export default {"btn_add_location":"RedactLocationComponent_btn_add_location__EEfFs","title":"RedactLocationComponent_title__j13lR","btn_wrapper":"RedactLocationComponent_btn_wrapper__VYCjB"};